module.exports = __webpack_public_path__ + "static/img/ad_director.e38538d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/ad_director.jpg
// module id = HkBN
// module chunks = 1